
let schools= [
{
_id: 6,
cod_ezor: "11",
ezor: "القدس",
cod_beit_sefer: "339",
shem_beit_sefer: "سمر",
cod_hiter: "5212",
menahel: "ابو سنينة رافي",
ktovet: "الزهراء 14 القدس",
telefon: "02.626.1789",
prati: "1",
masa: "1",
traktor: "0",
ofnoa: "0",
otobus: "0",
grar: "0"
},

{
_id: 8,
cod_ezor: "11",
ezor: "القدس",
cod_beit_sefer: "62",
shem_beit_sefer: "المنار",
cod_hiter: "5194",
menahel: "ابو سرحان فل",
ktovet: "علي ابن ابي طالب",
telefon: "02.628.8431",
prati: "1",
masa: "1",
traktor: "0",
ofnoa: "0",
otobus: "0",
grar: "0"
},
{
_id: 10,
cod_ezor: "11",
ezor: "القدس",
cod_beit_sefer: "705",
shem_beit_sefer: "القدس",
cod_hiter: "5227",
menahel: "سلامة اسماعيل",
ktovet: "יالحريري 27",
telefon: "02.628.1911",
prati: "1",
masa: "1",
traktor: "0",
ofnoa: "1",
otobus: "0",
grar: "0"
},

{
_id: 12,
cod_ezor: "11",
ezor: "القدس",
cod_beit_sefer: "715",
shem_beit_sefer: "يعقوب",
cod_hiter: "5243",
menahel: "سامي ن. الدين",
ktovet: "احيان الصفا 41",
telefon: "02.628.5751",
prati: "1",
masa: "0",
traktor: "0",
ofnoa: "1",
otobus: "1",
grar: "0"
},
{
_id: 13,
cod_ezor: "11",
ezor: "القدس",
cod_beit_sefer: "716",
shem_beit_sefer: "حنان",
cod_hiter: "5213",
menahel: "رازم فايز ",
ktovet: "الرشيد 15",
telefon: "02.626.4510",
prati: "1",
masa: "1",
traktor: "0",
ofnoa: "0",
otobus: "1",
grar: "1"
},
{
_id: 14,
cod_ezor: "11",
ezor: "القدس",
cod_beit_sefer: "720",
shem_beit_sefer: "أمجد",
cod_hiter: "5175",
menahel: "محمد غنام",
ktovet: "دوار مندلباوم",
telefon: "02.582.2939",
prati: "1",
masa: "1",
traktor: "1",
ofnoa: "0",
otobus: "0",
grar: "0"
},
{
_id: 15,
cod_ezor: "11",
ezor: "القدس",
cod_beit_sefer: "721",
shem_beit_sefer: "ابو رمضان",
cod_hiter: "5184",
menahel: "قمر ريمون",
ktovet: "عمر ابن العاص 4",
telefon: "02.627.2220",
prati: "1",
masa: "1",
traktor: "0",
ofnoa: "0",
otobus: "0",
grar: "0"
},

{
_id: 20,
cod_ezor: "11",
ezor: "القدس",
cod_beit_sefer: "752",
shem_beit_sefer: "طوطح",
cod_hiter: "5185",
menahel: "يعقوب طوطح",
ktovet: "ابو عبيدة 2",
telefon: "02.628.1571",
prati: "1",
masa: "1",
traktor: "0",
ofnoa: "0",
otobus: "1",
grar: "0"
},

{
_id: 22,
cod_ezor: "11",
ezor: "القدس",
cod_beit_sefer: "766",
shem_beit_sefer: " يوسف",
cod_hiter: "5251",
menahel: "ايوب بركان ",
ktovet: "طريق شعفاط 8",
telefon: "073.740.2004",
prati: "1",
masa: "1",
traktor: "0",
ofnoa: "0",
otobus: "0",
grar: "0"
},

{
_id: 24,
cod_ezor: "11",
ezor: "القدس",
cod_beit_sefer: "775",
shem_beit_sefer: "الجليل",
cod_hiter: "5276",
menahel: "أكرم طوطح",
ktovet: "الزهراء 3 القدس",
telefon: "",
prati: "1",
masa: "1",
traktor: "0",
ofnoa: "0",
otobus: "0",
grar: "0"
},


]

export default schools